export default (scroller) => {
    if(document.querySelector('.simple-title__filter')){
      let simpleTitleFilter = document.querySelector('.simple-title__filter');
      let simpleSortRow = document.querySelector('.simple-title__sort-row');
      let simpleSort = document.querySelector('.simple-title__sort-column');

      if(simpleSort == null){
        simpleTitleFilter.style.display = "none";
      } else {

        simpleTitleFilter.addEventListener('click', () => {
          simpleTitleFilter.classList.toggle('open-filter-sort');
          simpleSortRow.classList.toggle('open-filter-sort');

          setTimeout(() => {
            scroller.update();
          }, 600);
        });
      }



    }
}